import { IsNotEmpty, IsUUID } from 'class-validator';

export class PrintFlowDto {
  @IsNotEmpty()
  @IsUUID()
  id: string;
}
